<div class="container">
     <div class="main-container-analyze">
          <div class="table">
               <label class="header">flight totals</label>
               <div class="table-container">
                    <div *ngIf="analyzeData$ | async as data">
                         <p-table [value]="data">
                              <ng-template pTemplate="body" let-data>
                                   <tr>
                                        <td class="item-label">{{ data.totalTime.label }}</td>
                                        <td class="item-value">{{ data.totalTime.value}}</td>
                                   </tr>
                                   <tr>
                                        <td class="item-label">{{ data.currentYear.label}}</td>
                                        <td class="item-value">{{ data.currentYear.value}}</td>
                                   </tr>
                                   <tr>
                                        <td class="item-label">{{ data.currentMonth.label}}</td>
                                        <td class="item-value">{{ data.currentMonth.value}}</td>
                                   </tr>
                                   <tr>
                                        <td class="item-label">{{ data.lastSixMonths.label}}</td>
                                        <td class="item-value">{{ data.lastSixMonths.value}}</td>
                                   </tr>
                                   <tr>
                                        <td class="item-label">{{ data.lastTwelveMonths.label}}</td>
                                        <td class="item-value">{{ data.lastTwelveMonths.value}}</td>
                                   </tr>
                                   <tr>
                                        <td class="item-label">{{ data.totalDistanceFlown.label}}</td>
                                        <td class="item-value">{{ data.totalDistanceFlown.value | number: '1.0-0'}} nm
                                        </td>
                                   </tr>
                                   <tr>
                                        <td class="item-label">{{ data.totalPassengerCount.label}}</td>
                                        <td class="item-value">{{ data.totalPassengerCount.value | number: '1.1'}}
                                        </td>
                                   </tr>
                              </ng-template>
                         </p-table>
                    </div>
               </div>
          </div>
          <div class="table">
               <label class="header">charts</label>
               <div class="charts-container">
                    <p-table [value]="chartRows" (selectionChange)="onSelectedRow($event)" selectionMode="single"
                         dataKey="id" [(selection)]="selectedRow">
                         <ng-template pTemplate="body" let-data>
                              <!-- FIX ME: Enbale Row 2 when data is there from API -->
                              <tr [pSelectableRow]="data">
                                   <td>
                                        <div
                                             [ngClass]="{'item-label': (data.id != 6), 'item-label-disabled': (data.id == 6)}">
                                             {{ data.label}}
                                        </div>
                                   </td>
                                   <td>
                                        <div
                                             [ngClass]="{'item-value': (data.id != 6), 'item-value-disabled': (data.id == 6)}">
                                             <i class="pi pi-angle-right"></i>
                                        </div>
                                   </td>
                              </tr>
                         </ng-template>
                    </p-table>
               </div>
          </div>
     </div>
</div>